import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, statusTypesData, urlsData } from "@/data";
import { editContributorMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditContributor = (id) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [editContributorAction, { loading }] = useMutation(editContributorMutation);

    const editContributor = async ({ appleId, name, nameAr }) => {
        try {
            await editContributorAction({
                onCompleted: () => {
                    navigate(urlsData.routes.contributors.url);

                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", { entity: t("contributors.entity") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    data: {
                        appleId,
                        name,
                        name_ar: nameAr,
                    },
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editContributor,
        loading,
    };
};

export default useEditContributor;
